import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UnionDomain } from './union.domain';
import { ToastrService } from 'ngx-toastr';
import { Assessment } from '../models/assessment';
import { Union } from '../models/union';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SmsService {
  baseURL: string = 'https://bulksmsbd.net/api/smsapi';
  api_key: string = 'U2awuAY2chrBHpefSDvb';
  type: string = 'text';
  senderid: string = '8809617615257';
  message: string = ''; //= 'Online Digital Holding Registration Successful.\\n1 no Bijoypur Union Parishad\\n\\nDevOps Solutions BD'
  constructor(
    private httpClient: HttpClient,
    public unionDomain: UnionDomain,
    private toastr: ToastrService
  ) {}

  private replacePlaceholdersForUnion(message: string, union: Union): string {
    return message.replace(/{{(union.*?)}}/g, (_, key) => {
      const unionKey = key.trim().split('union.')[1] as keyof Union;
      return union[unionKey] !== undefined ? union[unionKey].toString() : '';
    });
  }

  private replacePlaceholdersForAssessment(
    message: string,
    assessment: Assessment
  ): string {
    return message.replace(/{{(assessment.*?)}}/g, (_, key) => {
      const assessmentKey = key
        .trim()
        .split('assessment.')[1] as keyof Assessment;
      if (
        assessmentKey !== null &&
        assessmentKey !== undefined &&
        assessment[assessmentKey] !== undefined &&
        assessment[assessmentKey] !== null
      ) {
        return assessment[assessmentKey]!.toString();
      } else {
        return '';
      }
    });
  }

  sendAssessmentCreateSms = (mobile_number: any) => {
    this.message =
      this.unionDomain.unionData.create_assessment_msg +
      '\\n\\nDevOps Solutions BD';
    return this.httpClient.get<any>(
      `${this.baseURL}?api_key=${this.api_key}&type=${this.type}&number=${mobile_number}&senderid=${this.senderid}&message=${this.message}`
    );
  };

  sendTaxCollectionSms = (
    assessment: Assessment,
    union: Union,
    amount: number
  ) => {
    this.message =
      this.unionDomain.unionData.tax_collection_msg +
      '\\n\\nDevOps Solutions BD';
    this.message = this.replacePlaceholdersForUnion(this.message, union);
    this.message = this.replacePlaceholdersForAssessment(
      this.message,
      assessment
    );
    this.message = this.message.replace('{{tax_amount}}', amount.toString());
    this.message = this.message.replace(/\n/g, '\\n\\n');
    return this.httpClient.get<any>(
      `${this.baseURL}?api_key=${this.api_key}&type=${this.type}&number=${assessment.mobile_number}&senderid=${this.senderid}&message=${this.message}`
    );
  };

  sendQuickSmsToMultipleNumbers = (mobile_numbers: string, message: string) => {
    const numbersArray = mobile_numbers.split(',');
    
    this.message = message + '\\n\\nDevOps Solutions BD';
    this.message = this.message.replace(/\n/g, '\\n\\n');
    numbersArray.forEach((number) => {
      this.httpClient
        .get<any>(
          `${this.baseURL}?api_key=${this.api_key}&type=${
            this.type
          }&number=${number.trim()}&senderid=${this.senderid}&message=${
            this.message
          }`
        )
        .subscribe({
          next: (res) => {
            if (res.response_code == 202) {
              this.toastr.success(res.success_message);
            } else {
              this.toastr.error(res.error_message);
            }
          },
        });
    });
  };

  // Get SMS balance from the API
  getSmsBalance(): Observable<{response_code: number, balance: number}> {
    const balanceUrl = 'https://bulksmsbd.net/api/getBalanceApi';
    return this.httpClient.get<{response_code: number, balance: number}>(
      `${balanceUrl}?api_key=${this.api_key}`
    );
  }
}
